module.exports = __webpack_public_path__ + "static/media/Ankur.53d1be2e.png";